import ElementalPage from '@modules/elemental-page/page/ElementalPage';
import { loader } from '@modules/elemental-page/loaders/elemental-page-loader.server';
import { getPreloadImageLink } from '@modules/images';
import type { APHandle } from '~/modules/root';
import { getRouteData } from '~/modules/root/util/get-route-data';
import {
    getCanonicalHreflang,
    createMetaTitle,
    createOGTags,
    createMetaDescription,
    mergeMeta,
} from '~/modules/seo';
import { getImagesSizes } from '~/utils/image-sizes-utils';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    (props) => {
        const { data, matches } = props;
        const { appData } = getRouteData(matches);
        const imageConfigProps = appData?.imageConfigProps;
        const title = createMetaTitle(props, ['Ecommerce Launch']);
        const description = createMetaDescription([]);

        const heroImage = data?.modules.filter((item) => {
            return item.type === 'EcomWelcomeModule';
        })?.[0];

        const imageDesktop = heroImage?.image?.desktopSrc;
        const imageMobile = heroImage?.image?.mobileSrc;
        const preloadMobileLinks = imageMobile
            ? getPreloadImageLink(imageConfigProps, undefined, imageMobile)
            : [];
        const preloadDesktopLinks = imageDesktop
            ? getPreloadImageLink(
                  imageConfigProps,
                  imageDesktop,
                  undefined,
                  getImagesSizes(890)
              )
            : [];
        const preloadImageLinks =
            data?.deviceType === 'mobile'
                ? preloadMobileLinks
                : preloadDesktopLinks;
        return [
            {
                title,
            },
            { name: 'description', content: description },
            ...createOGTags({
                meta: props,
                title,
                description,
            }),
            ...getCanonicalHreflang(props),
            ...preloadImageLinks,
        ];
    }
);

export { loader };
export default ElementalPage;

export const handle: APHandle = {
    disableSearch: true,
    disableTopNavAnimation: false,
};
